import service from './service';

// 首页 数据
export const getProducts =()=>service('/mock/wck/website/products',"POST") ;